import { render, staticRenderFns } from "./teacher-list.vue?vue&type=template&id=505cb561&scoped=true"
import script from "./teacher-list.vue?vue&type=script&lang=js"
export * from "./teacher-list.vue?vue&type=script&lang=js"
import style0 from "./teacher-list.vue?vue&type=style&index=0&id=505cb561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505cb561",
  null
  
)

export default component.exports